import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import { AuthState, AuthAction, AuthActionTypes } from './types'

export const authInitialState: AuthState = {
  errors: {
    changePassword: null,
    resetPassword: null
  },
  isAuthenticated: false,
  isFetchingRegistration: false,
  isFetchingLoggedIn: false,
  isFetchingVerification: false,
  isPasswordChanging: false,
  registrationData: null,
  identity: null,
  isAdmin: false,
  publicEmail: ''
}

export const authReducer: Reducer<AuthState> = createReducer<
  AuthState,
  AuthAction
>(authInitialState, {
  [AuthActionTypes.CREATE_ACCOUNT_REQUEST]: (state: AuthState) => ({
    ...state,
    isFetchingRegistration: true,
    registrationData: null
  }),
  [AuthActionTypes.CREATE_ACCOUNT_SUCCESS]: (state: AuthState, action) => ({
    ...state,
    isFetchingRegistration: true,
    registrationData: action.payload.registrationInfo
  }),
  [AuthActionTypes.CREATE_ACCOUNT_FAIL]: (state: AuthState) => ({
    ...state,
    isFetchingRegistration: true,
    registrationData: null
  }),
  [AuthActionTypes.CLEAR_REGISTRATION_DATA]: (state: AuthState) => ({
    ...state,
    registrationData: null
  }),
  [AuthActionTypes.GET_VERIFICATION_REQUEST]: (state: AuthState) => ({
    ...state,
    isFetchingVerification: false,
    access_token: ''
  }),
  [AuthActionTypes.GET_VERIFICATION_SUCCESS]: (state: AuthState, action) => ({
    ...state,
    isFetchingVerification: true,
    access_token: action.payload.access_token,
    isAuthenticated: true
  }),
  [AuthActionTypes.GET_VERIFICATION_FAIL]: (state: AuthState) => ({
    ...state,
    isFetchingVerification: false,
    access_token: ''
  }),
  [AuthActionTypes.LOGIN_REQUEST]: (state: AuthState) => ({
    ...state,
    isFetchingLoggedIn: false,
    isAuthenticated: false
  }),
  [AuthActionTypes.LOGIN_SUCCESS]: (state: AuthState, action) => ({
    ...state,
    isFetchingLoggedIn: true,
    isAuthenticated: true,
    access_token: action.payload.access_token,
    identity: action.payload.identity
  }),
  [AuthActionTypes.LOGIN_FAIL]: (state: AuthState) => ({
    ...state,
    isFetchingLoggedIn: false,
    isAuthenticated: false,
    access_token: '',
    identity: null
  }),
  [AuthActionTypes.LOGOUT]: (state: AuthState) => ({
    ...state,
    isAuthenticated: false,
    access_token: '',
    identity: null
  }),
  [AuthActionTypes.AUTHENTICATED]: (state: AuthState) => ({
    ...state,
    isAuthenticated: true
  }),
  [AuthActionTypes.ADMIN]: (state: AuthState, action) => ({
    ...state,
    isAdmin: action.payload
  }),
  [AuthActionTypes.CHANGE_PASSWORD_REQUEST]: (state: AuthState, action) => ({
    ...state,
    isPasswordChanging: true
  }),
  [AuthActionTypes.CHANGE_PASSWORD_SUCCESS]: (state: AuthState) => ({
    ...state,
    isPasswordChanging: false,
    errors: {
      changePassword: null
    }
  }),
  [AuthActionTypes.CHANGE_PASSWORD_FAIL]: (state: AuthState, action) => {
    return {
      ...state,
      isPasswordChanging: false,
      errors: {
        changePassword: action.payload
      }
    }
  },
  // forgot password rest by email
  [AuthActionTypes.REST_PASSWORD_REQUEST]: (state: AuthState) => ({
    ...state,
    isPasswordChanging: true
  }),
  [AuthActionTypes.REST_PASSWORD_SUCCESS]: (state: AuthState, action) => ({
    ...state,
    isPasswordChanging: false,
    errors: {
      resetPassword: null
    }
  }),
  [AuthActionTypes.REST_PASSWORD_FAIL]: (state: AuthState, action) => ({
    ...state,
    isPasswordChanging: false,
    errors: {
      resetPassword: action.payload
    }
  }),

  [AuthActionTypes.CHANGE_PASSWORD_BY_EMAIL_REQUEST]: (state: AuthState) => ({
    ...state,
    isPasswordChanging: true
  }),
  [AuthActionTypes.CHANGE_PASSWORD_BY_EMAIL_SUCCESS]: (
    state: AuthState,
    action
  ) => ({
    ...state,
    ...action.payload,
    isPasswordChanging: false,
    errors: {
      resetPassword: null
    }
  }),
  [AuthActionTypes.CHANGE_PASSWORD_BY_EMAIL_FAIL]: (
    state: AuthState,
    action
  ) => ({
    ...state,
    isPasswordChanging: false,
    errors: {
      resetPassword: action.payload
    }
  }),
  [AuthActionTypes.SET_EMAIL_TO_STORE]: (state: AuthState, action) => ({
    ...state,
    publicEmail: action.payload
  })
})
